module.exports = __webpack_public_path__ + "public/img/touxiang.d7476b6b.png";